import { useMemo } from 'react';

import { useTrackableData } from './useTrackableData.hook';

export const useEditableTrackableData = () => {
  const { trackableData } = useTrackableData();

  const editableTrackableData = useMemo(
    () => ({
      ...trackableData,
      contentUpdatedAt: trackableData.updatedAt,
    }),
    [trackableData],
  );

  return { trackableData: editableTrackableData };
};
